export enum JobStatus {
  ADDED,
  RUNNING,
  PAUSED,
  RUNNING_TEST,
  CANCELD,
  DONE,
  ERROR,
}
